/* a17-cross-sell.js — panier : proposer d'abord les produits COMPLEMENTAIRES.

   Le composant du theme appelle l'API de recommandations sans preciser
   l'intention : il renvoie donc des produits SIMILAIRES. Dans un panier c'est
   contre-productif — qui vient d'ajouter un vase ne veut pas un second vase,
   il veut le mug assorti. On interroge donc 'complementary' (metachamp rempli
   par build_reco.py), avec repli automatique sur 'related' quand la fiche n'a
   pas de complementaires. Aucune modification de main.js. */
(function () {
  function brancher() {
    var C = window.customElements.get('cc-cart-cross-sell');
    if (!C || C.__a17) return false;
    var origine = C.prototype.init;
    C.prototype.init = function () {
      var self = this;
      var primaire = this.dataset.from;
      var secours = this.dataset.fallback;
      if (!primaire) return origine.call(this);
      fetch(primaire)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var d = document.createElement('div');
          d.innerHTML = html || '';
          var pl = d.querySelector('.product-grid');
          if (pl && pl.querySelector('a[href*="/products/"]')) {
            var cible = self.querySelector('.product-grid');
            if (cible) {
              cible.innerHTML = pl.innerHTML;
              self.classList.remove('hidden');
              self.querySelectorAll('carousel-slider').forEach(function (el) {
                if (el.refresh) el.refresh();
              });
            }
            return;
          }
          replier();
        })
        .catch(replier);
      function replier() {
        if (!secours) { self.classList.add('hidden'); return; }
        self.dataset.from = secours;
        origine.call(self);
        self.dataset.from = primaire;
      }
    };
    C.__a17 = true;
    return true;
  }
  if (!brancher()) {
    var n = 0;
    var t = setInterval(function () { if (brancher() || ++n > 60) clearInterval(t); }, 250);
  }
})();
